/**
 * CheckIcon Component
 * 
 * Checkmark icon for checkboxes.
 */

interface CheckIconProps {
  className?: string;
}

export function CheckIcon({ className = '' }: CheckIconProps) {
  return (
    <svg 
      className={className}
      width="12" 
      height="12" 
      viewBox="0 0 12 12" 
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M2 6L5 9L10 3" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}

